import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { Router } from '@angular/router';

import { PIDService } from '../../services/pid.service';
import { NotificationService } from '../../services/notification.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { PidTableService } from '../../services/pidtable.service';

import * as _ from 'lodash';
import { toInteger } from 'lodash';

@Component({
  selector: 'nestas-pid-card',
  templateUrl: './pid-card.component.html',
  styleUrls: ['./pid-card.component.scss']
})
export class NestasPIDCardComponent implements OnInit {

  @Input() pid;
  @Input() parentPID;
  @Input() pids;
  @Input() editable: Boolean;
  @Input() picture: Boolean;
  @Input() doUpdateFilter;
  @Input() reloadHome;


  @ViewChild('modalCopyPID') modalCopyPID;
  @ViewChild('modalEditPID') modalEditPID;

  //@Output() reloadHome = new EventEmitter<string>();

  fileToUpload = null;
  rooms = [];
  transferEmail = null;
  transferType: "readonly";
  transferSubType = '';
  types: string[];
  steps: [];
  showActions = false;
  modal = {
    editPID: false,
    deletePID: false,
    newPID: false,
    transferPID: false
  };
  view = false;

  constructor(private _pidService: PIDService, private _notification: NotificationService,
    private _user: UserService, private _router: Router, public translate: TranslateService,
    private _pidtable: PidTableService) {

  }

  addRoom() {
    this.rooms.push({ room: '' });
  }

  get user() {
    return this._user;
  }

  type2imgfn = (rtype) => this._pidtable.type2imgfn(rtype);
  transferInfo = pid => this._pidtable.transferInfo(pid);
  sharedInfo = pid => this._pidtable.sharedInfo(pid, this._user.me());

  private _initRoomsWrapper() {
    this.rooms = _.map(this.pid.rooms, r => {
      return ({ room: r });
    });
  }

  ngOnInit() {
    //console.log("pid card init", this.reloadHome, this.reload);
    this._pidService.getPIDTypes()
      .subscribe((response: any) => {
        this.types = response.types;
      }, error => {
        console.log(error);
      });
    this.transferType = 'readonly';
    this._initRoomsWrapper();
  }

  private _updatePID(pid) {
    delete pid.owner;
    this.pid = _.merge(this.pid, pid);
    this._initRoomsWrapper();
    this.modal.editPID = false;
  }

  editPID() {
    this.pid.rooms = _.map(_.filter(this.rooms, r => {
      return (r.room);
    }), r => {
      return (r.room);
    });
    this._pidService.updatePID(this.pid, this._user.me()['_id']).subscribe(
      (ret: any) => {
        if (this.fileToUpload && ret.url) {
          this._pidService.uploadImg(ret.url, this.fileToUpload).subscribe(
            success => {
              this._updatePID(ret.pid);
            });
        } else {
          this._updatePID(ret.pid);
        }
      },
      err => {
        this._notification.errorServer(err);
      }
    )
  }

  removePID() {
  }

  getColor() {
    return this.pid['percentage'] > 70 ? "primary"
      : this.pid['percentage'] > 40 ? "accent"
        : "warn";
  }

  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    this.pid.file = { type: file.type, name: file.name }
  }

  stringify(data) {
    return JSON.stringify(data);
  }

  fallbackImg($event) {
    $event.target.src = '/assets/' + this.pid.type + '.png';
  }

  details() {
    if (this.editable) {
      this._router.navigate(['pid', this.pid._id]);
    }
  }

  displayActions() {
    if (this.editable) {
      this.showActions = true
    }
  }

  initTransferPID() {
    if (this.transferEmail) {
      console.log("transfer from pid-card type is", this, this.transferType, this.transferSubType);
      this._pidService.initTransfer(this.pid._id, this.transferEmail, this.transferType, this.transferSubType).subscribe(
        (pid: any) => {
          this.pid = pid;
          this.modal.transferPID = false;
          this._notification.info('MESSAGE.TRANSFER_INITIATED');
          console.log("reload home next");
          this.reloadHome.next('');
        },
        this._notification.errorServer
      );
    }
  }

  sharedWithMe(pid){
    //console.log("sharedwihtme", pid.PIDOwner, this._user.me(), pid.PIDOwner['_id'] != this._user.me()['_id']);
    return pid && pid.sharedWith && pid.sharedWith.map(x => x.email).indexOf(this.useremail()) > -1 && pid.PIDOwner['_id'] != this._user.me()['_id'];
  }

  allowTransfer() {
    return true;

    /*if (this.pid.sharedWith) {
      //console.log("shared with", this.pid.sharedWith._id, this._user.me()['_id']);
      if (this.pid.sharedWith.filter(x => x._id == this._user.me()['_id'])) {
        return false;
      }
    }*/

    if (!this.pid.children || !this.pid.children.length) {
      return true;
    }

    return _.every(this.pid.children, subPid => {
      return !subPid.copy;
    })
  }

  userIsAllowed() {
    return !this._user.expired() && !this.pid.expired;
  }

  useremail() {
    return this._user.me()['email'];
  }

  reload() {
    this.reloadHome.next('');
  }

}
